var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isActive)?_c('div',{staticClass:"ui-loader",style:({
        position: _vm.staticLoader ? 'relative' : '',
    })},[_c('div',{staticClass:"ui-loader-wrapper flex flex-column items-center"},[_c('div',{staticClass:"ui-loader__spinner"}),_vm._v(" "),(!_vm.staticLoader)?_c('div',{staticClass:"ui-loader__logo"},[_c('LogoSvg')],1):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }